import * as React from "react";
import $ = require('jquery');
export interface IDragAndDropProps {
	items: Array<IATagItem|IBoxItem|IGalleryItem|IDocumentItem>;
	template?: string;
	changed: Function;
	titleChangeHandler?: Function;
	beforeDragChangeHandler?: Function;
	removeClickHandler?: Function;
	coponent_id :string;
    editMode:boolean;
}

export interface IDragAndDropState {
	items:Array<IATagItem|IBoxItem|IGalleryItem|IDocumentItem>;
}
export interface IDefaultTagItem{
    id: number;
    name: string;
}
export interface IATagItem{
    id: number;
    name: string;
    url: string;
}
export interface IBoxItem{
    id: number;
    title: string;
}
export interface IGalleryItem{
    id: number;
    title: string;
    img: string;
    imgLarge: string;
}
export interface IDocumentItem{
    id: number;
    title: string;
    img: string;
    extension: string;
}

export class DragAndDrop extends React.Component<IDragAndDropProps, IDragAndDropState>{


	private dragged:any;
	private over:any;
	private nodePlacement:string;
	private placeholder:HTMLLIElement;
	constructor(props:IDragAndDropProps){
		super(props);
		// set initial state

		this.placeholder = document.createElement("li");
		this.placeholder.className = "sortable_placeholder item";

		this.state = {
			items : this.props.items==undefined?[]:this.props.items
		};

    }

	private dragOverHandler(e): void {
		e.preventDefault();
        if ( this.props.editMode === false ) {
            return;
        }
		this.dragged.style.display = "none";
		var target:any = e.target;
		if ( target.className.indexOf('item') === -1 ) {
			target = target.parentNode;
		}


		if (target.className.indexOf('item') === -1 ) {
			if( target.parentNode.className.indexOf("sortable_placeholder") > -1 ){
                return;
            }else{
			    this.over = target.parentNode;
            }
		}else{
			if( target.className.indexOf("sortable_placeholder") > -1 ) {
                return;
            }else{
			    this.over = target;
            }

		}
		// Inside the dragOver method
		var parent:any 		= target.parentNode;
		if ( $(parent).hasClass('sortable_container') === false ) {
			parent = $(parent).find('.sortable_container:first')[0];
		}
		//horisontal
	    var relX:number 	= e.clientX - this.over.offsetLeft;
		var width:number 	=  e.clientX - this.over.offsetWidth / 2;
		if( relX < width ) {
			this.nodePlacement = "after";
			target = target.nextElementSibling;
		}else if( relX > width) {
			this.nodePlacement = "before";
		}

		try{
			if ( target === null ) {
			    parent.appendChild(this.placeholder);
			}else{
				parent.insertBefore(this.placeholder, target);
			}

		}catch(e){
			console.log('nem sikerült a placeholdert, a target elé helyezeni');
		}

	}

	private dragStartHandler(e): void {
        if ( this.props.editMode === false ) {
            return;
        }
		if ( this.props.beforeDragChangeHandler !== undefined) {
		    this.props.beforeDragChangeHandler();
		}
		this.dragged = e.currentTarget;
		this.placeholder.innerHTML = this.dragged.innerHTML;
		e.dataTransfer.effectAllowed = 'move';
		// Firefox requires dataTransfer data to be set
		e.dataTransfer.setData("text/html", e.currentTarget);
	}

	private dragEndHandler(e): void {
	    e.preventDefault();
        if ( this.props.editMode === false ) {
            return;
        }
		this.dragged.style.display = "inline-block";
		try{
			this.dragged.parentNode.removeChild(this.placeholder);
		}catch(e){
			console.error('nincs a ul-en belül a placeholder');
			console.log('ul', this.dragged.parentNode);
			console.log('placeholder', this.placeholder);
			$('.sortable_placeholder').remove();
			return;
		}
	    // Update data
	    var data:any 	= this.state.items;
	    var from:number = Number(this.dragged.dataset.id);
	    var to:number 	= Number(this.over.dataset.id);

	    data.splice(to, 0, data.splice(from, 1)[0]);

		if ( from !== to ) {
			this.setState({items: data} as IDragAndDropState);
			this.props.changed(data);
		}else{
			console.log('not modifed');
		}
	}

    render() {
        var items = this.state.items;
		var template:string = 'a_tag';
		if ( this.props.template !== undefined ) {
		    template = this.props.template;
		}
        return (
			<div className="sortable_container" onDragOver={ e => this.dragOverHandler(e) }>
				{items.map((item:any, i:number) => {
					if ( template === 'clickable_list') {
						return <li
								className="item"
								data-title={item.name}
								data-id={i}
					            key={i}
					            draggable={ this.props.editMode }
					            onDragEnd={ e => this.dragEndHandler(e) }
					            onDragStart={ e => this.dragStartHandler(e) }
							>
							<a onClick={ (e:any) => { this.props.titleChangeHandler(item, e.target.value); } }
            >{item.name}</a>
                            { this.props.editMode === true?<a href="javascript:void(0);" className="remove_btn" title="" onClick={ e => this.props.removeClickHandler(e, item) }>
								<i className="ion-ios-close" ></i>
							</a>:'' }
						</li>;
					}else if ( template === 'default') {
						return <li
								className="item"
								data-title={item.name}
								data-id={i}
					            key={i}
					            draggable={ this.props.editMode }
					            onDragEnd={ e => this.dragEndHandler(e) }
					            onDragStart={ e => this.dragStartHandler(e) }
							>
							<span>{item.name}</span>
                            { this.props.editMode === true?<a href="javascript:void(0);" className="remove_btn" title="" onClick={ e => this.props.removeClickHandler(e, item) }>
								<i className="ion-ios-close" ></i>
							</a>:'' }
						</li>;
					}else if ( template === 'a_tag') {
						return <li
								className="item"
								data-title={item.url}
								data-id={i}
					            key={i}
					            draggable={ this.props.editMode }
					            onDragEnd={ e => this.dragEndHandler(e) }
					            onDragStart={ e => this.dragStartHandler(e) }
							>
							<a href={item.url}>{item.name}</a>
						</li>;
					}else if ( template === 'box') {
						var id:string = this.props.coponent_id +'_'+ i;
						return <li
								className="item box"
								data-title={item.title}
								data-id={i}
					            key={i}
					            draggable={ this.props.editMode }
					            onDragEnd={ e => this.dragEndHandler(e) }
					            onDragStart={ e => this.dragStartHandler(e) }
							>
                            <h3 className="bgcolor">
                                <input type="text" value={ item.title } onChange={ (e:any) => { this.props.titleChangeHandler(item, e.target.value); } } />
                            </h3>

                            { this.props.editMode === true?<a href="javascript:void(0);" className="remove_btn" title="" onClick={ e => this.props.removeClickHandler(e, item) }>
								<i className="ion-ios-close" ></i>
							</a>:'' }


							<div className="box-body is-container container"
							id={ id }
							dangerouslySetInnerHTML={{__html: item.html}}>
							</div>
						</li>;
					}else if ( template === 'gallery') {
						var id:string = this.props.coponent_id +'_'+ i;
                        var imgLarge:string = item.img;
                        if ( item.img !== undefined) {
                            imgLarge = item.imgLarge;
                        }
						return <li
								className="item box"
								data-title={item.title}
								data-id={i}
					            key={i}
					            draggable={ this.props.editMode }
					            onDragEnd={ e => this.dragEndHandler(e) }
					            onDragStart={ e => this.dragStartHandler(e) }
							>
                            <a href={imgLarge} data-lightbox="gallery"  data-title={ item.title }>
							    <img src={item.img} />
                            </a>
                            <h3>
                                <input type="text" value={ item.title } onChange={ (e:any) => { this.props.titleChangeHandler(item, e.target.value); } } />
                            </h3>

                            { this.props.editMode === true?<a href="javascript:void(0);" className="remove_btn" title="" onClick={ e => this.props.removeClickHandler(e, item) }>
								<i className="ion-ios-close" ></i>
							</a>:'' }


						</li>;
					}else if ( template === 'documents') {
						var id:string = this.props.coponent_id +'_'+ i;
						return <li
								className="item box"
								data-title={item.title}
								data-id={i}
					            key={i}
					            draggable={ this.props.editMode }
					            onDragEnd={ e => this.dragEndHandler(e) }
					            onDragStart={ e => this.dragStartHandler(e) }
							>
							<a href={item.img} target="_blank">
								<img src={ '/img/icons/512px/'+item.extension+'.png'} />
							</a>
                            <h3>
                                <input type="text" value={ item.title } onChange={ (e:any) => { this.props.titleChangeHandler(item, e.target.value); } } />
                            </h3>

                            { this.props.editMode === true?<a href="javascript:void(0);" className="remove_btn" title="" onClick={ e => this.props.removeClickHandler(e, item) }>
								<i className="ion-ios-close" ></i>
							</a>:'' }


						</li>;
					}
				})}
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./avernus/DragAndDrop/source/DragAndDrop.tsx